module.exports = __webpack_public_path__ + "toBride2-we-r-w.2f13d87e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-r-w.jpg
// module id = pElt
// module chunks = 0